import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { apiGET } from '../../utilities/apiHelpers';
import { API_URL } from '../../config';
// import { useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const MainSlider = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  // const navigate = useNavigate();

  const fetchBanners = async () => {
    try {
      const response = await apiGET(`${API_URL}/v1/sliderImg/get-all-slider-img`);
      const fetchedData = response?.data?.data?.data || [];
      const sorted = fetchedData.sort((a, b) => a.position - b.position);
      setProducts(sorted);
    } catch (error) {
      console.error('Error fetching banners:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const settings = {
    dots: true,
    dotsClass: "slick-dots banner-dots-specific",
    infinite: products.length > 1,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    customPaging: (i) => (
      <div className="custom-line-indicator"></div>
    ),
  };

  if (loading) {
    return (
      <div className="px-4 mt-2">
        {/* Skeleton also uses aspect ratio to match the real slider */}
        <Skeleton className="aspect-[16/9] md:aspect-[21/9] lg:h-[380px] w-full" borderRadius="1.5rem" baseColor='#ccecee' />
      </div>
    );
  }

  if (products.length === 0) return null;

  return (
    <div className="main-banner-container w-full relative px-2 md:px-4">
      <style>{`
        .main-banner-container .banner-dots-specific {
            bottom: 10px !important;
            display: flex !important;
            justify-content: center !important;
            list-style: none !important;
            padding: 0 !important;
            width: 100% !important;
        }
        .main-banner-container .banner-dots-specific li {
            margin: 0 4px !important;
            width: 20px !important;
            height: 4px !important;
        }
        @media (min-width: 768px) {
            .main-banner-container .banner-dots-specific li {
                width: 35px !important;
            }
        }
        .main-banner-container .banner-dots-specific li button:before {
            display: none !important;
        }
        .main-banner-container .custom-line-indicator {
            width: 100%;
            height: 4px;
            background-color: #D1E9F0; 
            border-radius: 10px;
        }
        .main-banner-container li.slick-active .custom-line-indicator {
            background-color: #14967F; 
        }
      `}</style>

      <Slider {...settings}>
        {products.map((item) => (
          <div key={item._id} className="outline-none py-2">
            <div 
              className="relative w-full overflow-hidden rounded-[12px] md:rounded-[25px] cursor-pointer 
                         aspect-[16/7] sm:aspect-[16/6] md:h-[300px] lg:h-[380px]"
              // onClick={() => navigate('/products')}
            >
              <img
                src={item.sliderImgUrl}
                alt="Banner"
                /* Using object-contain on small screens ensures the WHOLE image is visible.
                   Using object-cover on medium+ screens fills the space professionally.
                */
                className="w-full h-full object-contain md:object-cover bg-white"
                onError={(e) => { e.target.src = 'https://via.placeholder.com/1200x400?text=Medicine+Care'; }}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default MainSlider;